import { AppState } from "../root.reducer";

export const isManagementContactActiationLoadingSelector = (state: AppState) => state.activation.isLoading;
export const managementContactActivationSelector = (state: AppState) => state.activation.activation;